import React from 'react';
import ReactLightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { navigate } from 'gatsby';

export class Lightbox extends React.Component {
  state = {
    index: this.props.lightbox && this.props.lightbox.index,
  };

  render() {
    const lightbox = this.props.lightbox;

    if (!lightbox) {
      return null;
    }

    const curr = lightbox.fluids[this.state.index];
    const prev = lightbox.fluids[this.state.index - 1];
    const next = lightbox.fluids[this.state.index + 1];

    return (
      <ReactLightbox
        prevSrc={prev && (prev.originalImg || prev.src)}
        nextSrc={next && (next.originalImg || next.src)}
        mainSrc={curr && (curr.originalImg || curr.src)}
        onCloseRequest={this.handleClose}
        onMovePrevRequest={this.handleMovePrev}
        onMoveNextRequest={this.handleMoveNext}
      />
    );
  }

  handleMovePrev = () => {
    this.setState((state) => ({
      index: state.index - 1,
    }));
  };

  handleMoveNext = () => {
    this.setState((state) => ({
      index: state.index + 1,
    }));
  };

  handleClose = () => {
    navigate(this.props.location.pathname, { state: { lightbox: undefined } });
  };
}
